import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { globals } from '../globals';
import { GlobalService } from './global.service';

@Injectable({
  providedIn: 'root'
})
export class OcorrenciaAnexoService {

  constructor(private globalService: GlobalService, private http: HttpClient) {

  }    

  consultarPorIdOcorrencia(idOcorrencia) {
    return this.http.get<any>(globals.apiUrl + '/api/OcorrenciaAnexo/ListarPorIdOcorrencia',
      { params: new HttpParams().set('idOcorrencia', idOcorrencia) });
  }

  consultarPorIdOcorrenciaAnexo(id) {
    return this.http.get<any>(globals.apiUrl + '/api/OcorrenciaAnexo/Buscar',
      { params: new HttpParams().set('id', id) });
  }

  salvar(idOcorrencia, arquivos) {
    return this.http.post(globals.apiUrl + '/api/OcorrenciaAnexo/Salvar', arquivos, { params: new HttpParams().set('idOcorrencia', idOcorrencia) });
  }

  excluir(id) {
    return this.http.delete(globals.apiUrl + '/api/OcorrenciaAnexo/Excluir',
      { params: new HttpParams().set('id', id) });
  }
}
